export default __webpack_public_path__ + "static/media/risk_person.92375122.png";